const React = require('react')
const ReactDOM = require('react-dom/server')
const styles = require('./markdown.css')
const legacyStyles = require('./markdown-legacy.css')
const {LinkIcon} = require('@primer/octicons-react')

// Generated markdown used to contain inline SVG link icons. Since new markdown
// content does not contain these SVGs we do a clientside only replacement for
// empty octicon-link spans and replace them with the octicon-link SVG. This
// could also be done in the esi-proxy service but that would require
// regenerating many readmes.
const linkHtml = ReactDOM.renderToStaticMarkup(<LinkIcon verticalAlign="middle" />)
const replaceLinkIcons = parentNode => {
  const nodes = parentNode.querySelectorAll('span.octicon.octicon-link:empty')
  for (const node of nodes) {
    node.outerHTML = linkHtml
  }
}

const makeLinkIconsFocusable = parentNode => {
  const nodes = parentNode.querySelectorAll('a.anchor[tabindex="-1"]')
  for (const node of nodes) {
    node.removeAttribute('tabindex')
  }
}

const makePreElementsFocusable = parentNode => {
  const nodes = parentNode.getElementsByTagName('pre')
  for (const node of nodes) {
    node.setAttribute('tabindex', 0)
  }
}

const useMarkdown = markdown => {
  const ref = React.useRef()

  React.useEffect(() => {
    const {current: parentNode} = ref
    if (parentNode) {
      replaceLinkIcons(parentNode)
      makePreElementsFocusable(parentNode)
      makeLinkIconsFocusable(parentNode)
    }
  }, [ref, markdown])

  return {
    ref,
    dangerouslySetInnerHTML: {__html: markdown},
  }
}

function Markdown({markdown, id}) {
  return <div id={id} className={`${legacyStyles.markdown} ${styles.markdown}`} {...useMarkdown(markdown)} />
}

module.exports = Markdown
